import { useLayoutEffect, useRef } from "react";

export const useBeforeUnmount = (onUnmount: () => void) => {
	const onUnmountRef = useRef(onUnmount);
	onUnmountRef.current = onUnmount;

	useLayoutEffect(() => () => onUnmountRef.current(), []);
};
